const setLineDash = (ctx, value) => {
  ctx.setLineDash(value);
};

export { setLineDash };
